// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import utils from '../static/js/utils.js';
import MintUI from 'mint-ui';
import '../static/less/reset.css'
Vue.use(MintUI)
Vue.use(utils)
Vue.config.productionTip = false;
// console.log=function(){}
// console.warn=function(){}
// console.info=function(){}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});
router.afterEach((to,from, next) => {
  window.scrollTo(0,0)
})



// WEBPACK FOOTER //
// ./src/main.js